<template>
  <div :data-label="Label ? labelCaption : null" :class="classValueStyle" >
    <date-picker
      v-model="internalDate"
      :format="dateFormat"
      :lang="lang"
      :disabled="ReadOnly"
      :type="Type"
      :open.sync="isOpen"
      ref="picker"
      :popup-style="PopupStyle"
      :disabled-date="disabledOutOfSQLRange"
      :placeholder="PlaceHolder || dateFormat"
      :confirm="isConfirm"
      input-class="form-control"
      @input.native="onInputManual"
      @keydown.native="handleKeyDown"
      @change="onChange"
      @blur="onBlur"
      style="width:100%"
    >
      <template v-slot:header="{ emit }">
        <button class="mx-btn mx-btn-text mx-btn-local" @click="selectToday(emit)">
          {{$t('Shared.Today')}}
        </button>
      </template>
    </date-picker>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import es from 'vue2-datepicker/locale/es';
import en from 'vue2-datepicker/locale/en';
import ar from 'vue2-datepicker/locale/ar';
import Utils from "@/common/utils";
import { EventBus } from '@/event-bus.js';

export default {
  name: 'MdDateTime',
  components: { DatePicker },
  props: {
    Model: String,
    Label: String,
    Type: { type: String, default: 'date' },
    ReadOnly: Boolean,
    PlaceHolder: String,
    isConfirm: Boolean,
    invalidMessage: {
      type: String,
      default: ''
    },
    classValueInvalidStyle:String,
    OnPressEnter:Function,
    isRequired:Boolean,
    Change:Function,
    Blur:Function,
    isValid: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpen: false,
      internalDate: null,
      dateFormat: Utils.getFormatComponentDatePicker(this.Type),
      classValueStyle:"textlabel",
      inputKeydownListener: null,
      isTouched: false,
      isUpdatingFromParent: false,
      PopupStyle:{}
    };
  },
  computed: {
    invalidFeedbackMessage() {
      // Si hay mensaje externo, usarlo siempre
      if (this.invalidMessage !== null && this.invalidMessage !== '') {
        return this.invalidMessage;
      }

      // Validación interna
      if (this.isRequired && this.isTouched && (this.Model === null || this.Model === '')) {
        return this.$t('Msg.RequiredField');
      }

      return '';
    },

    internalClassValueStyle(){
        return this.classValueStyle ? this.classValueStyle : "textlabel";
    },

    labelCaption() {
      if (!this.isRequired) return this.Label;

      // PRIORIDAD 1: Error de validación personalizado (rango de fechas)
      if (this.invalidFeedbackMessage) {
        return this.Label + ' * ' + this.invalidFeedbackMessage;
      }
      // PRIORIDAD 2: Campo requerido vacío
      if (this.isRequired && !this.isValid && !this.internalDate) {
        return this.Label + ' * ' + this.$t('Msg.RequiredField');
      }
      // PRIORIDAD 3: Campo requerido (válido o pendiente)
      return this.Label + ' *';
    },


   lang() {
      const langCode = Utils.getLanguageComponentDatePicker();
      if (langCode === 'es') return es;
      if (langCode === 'en') return en;
      if (langCode === 'ar') return ar;
      return en;
    },
  },
  watch: {

    // isValid:function () {
    //     this.classValueStyle = this.internalDate ?  "textlabel":"textlabel-invalid";
    //    // this.isRequired ? this.Label =  this.Label + ' * ' + this.invalidFeedbackMessage : this.Label;
    // },
    isValid: {
      handler(newVal) {
        // Actualizar estilo basado en isValid, pero respetando internalDate
        if (!newVal) {
          // Si es inválido por rango de fechas, mostrar error
          this.classValueStyle = "textlabel-invalid";
        } else if (this.isRequired && this.isTouched && !this.internalDate) {
          // Si es requerido y no hay fecha
          this.classValueStyle = "textlabel-invalid";
        } else if (this.internalDate) {
          // Si hay fecha y es válido
          this.classValueStyle = "textlabel";
        } else {
          this.classValueStyle = "textlabel";
        }
      },
      immediate: true
    },

    Model: {
      immediate: true,
      handler(val) {
        this.isUpdatingFromParent = true;
        let cleanVal = val;
        if (this.Type === 'date' && typeof val === 'string' && val.includes('T')) {
          cleanVal = val.split('T')[0];
          if (cleanVal !== val) {
            this.$emit('input', cleanVal);
          }
        }
        const parsed = cleanVal ? this.parseModel(cleanVal) : null;
        this.internalDate = parsed;
        if (this.isRequired && this.isTouched && (!val)   ) {
          this.classValueStyle = "textlabel-invalid";
        } else {
          this.classValueStyle = "textlabel";
        }
        this.$nextTick(() => {
          this.isUpdatingFromParent = false;
        });
      }
    },

    internalDate(val) {
      if (this.isUpdatingFromParent) return;

      if (!this.isValid) {
        this.classValueStyle = "textlabel-invalid";
      } else if (this.isRequired && this.isTouched && !val) {
        this.classValueStyle = "textlabel-invalid";
      } else if (val) {
        this.classValueStyle = "textlabel";
      } else {
        this.classValueStyle = "textlabel";
      }

      if (!val) {
        this.$emit('input', null);
        return;
      }
      if (this.Type === 'date') {
        val = new Date(
          val.getFullYear(),
          val.getMonth(),
          val.getDate()
        );
      }

      const pad = n => String(n).padStart(2, '0');
      const yyyy = val.getFullYear();
      const mm = pad(val.getMonth() + 1);
      const dd = pad(val.getDate());
      const hh = pad(val.getHours());
      const mi = pad(val.getMinutes());

      let result;

      if (this.Type === 'date') {
        result = `${yyyy}-${mm}-${dd}`;
      } else {
        result = `${yyyy}-${mm}-${dd}T${hh}:${mi}:00`;
      }

      /*this.$nextTick(() => {
        this.forceInputDisplay();
      });*/

      this.$emit('input', result);

      EventBus.$emit('onChanged', {
        Changed: true,
        Value: val,
      });
    }
  },
  methods: {
    selectToday(emit){
      emit(new Date());
      this.isOpen = false;
    },
     disabledOutOfSQLRange(date) {
      const min = new Date(1753, 0, 1, 0, 0, 0);       // 01/01/1753
      const max = new Date(9999, 11, 31, 23, 59, 59);  // 31/12/9999
      return date < min || date > max;
    },
    onChange(){
      if(this.Change && typeof this.Change === 'function'){
        this.isTouched = true;
        this.Change();
      }
       EventBus.$emit('onChanged', {
          Changed: true,
          Value: this.Model,
       });
    },

    isInSqlRange(date) {
      const min = new Date(1753, 0, 1, 0, 0, 0);
      const max = new Date(9999, 11, 31, 23, 59, 59);
      return date >= min && date <= max;
    },

    onBlur(){
      if(this.Blur && typeof this.Blur === 'function'){
        this.Blur();
      }
    },

    normalizeDate(date) {
      if (!date) return date;
      if (this.Type === 'date') {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
      }
      return date;
    },

    handleKeyUp(e){
      if (e.key === "Enter" && typeof this.OnPressEnter === "function") {
        this.OnPressEnter();
      }
    },

    forceInputDisplay() {
      if (this.Type !== 'date') return;

      const input = this.$refs.picker?.$el?.querySelector('input');
      if (!input || !this.internalDate) return;


     // const start = input.selectionStart;
     // const end = input.selectionEnd;

      const pad = n => String(n).padStart(2, '0');

      const yyyy = this.internalDate.getFullYear();
      const mm = pad(this.internalDate.getMonth() + 1);
      const dd = pad(this.internalDate.getDate());

      let formatted;

      if (this.dateFormat && this.dateFormat.startsWith('DD')) {
        formatted = `${dd}/${mm}/${yyyy}`;
      } else {
        formatted = `${mm}/${dd}/${yyyy}`;
      }

      input.value = formatted;

      const newPos = input.value.length;

       this.$nextTick(() => {
        input.setSelectionRange(newPos, newPos);
      });
    },

    handleKeyDown(e) {
        if(e.key === 'Enter') {
          this.$nextTick(() => {
            if(this.internalDate && this.onEnterCompleteDate) {
              this.onEnterCompleteDate(this.internalDate);
            }
          });
        }
    },

    disabledRange(date) {
      const today = new Date();
      const min = new Date(today); min.setFullYear(today.getFullYear()-140);
      const max = new Date(today); max.setFullYear(today.getFullYear()+140);
      return date < min || date > max;
    },

    /*parseModel(val) {
      if (!val) return null;

      if (val instanceof Date) {
        return this.Type === 'date'
          ? new Date(val.getFullYear(), val.getMonth(), val.getDate())
          : val;
      }
      if (typeof val === 'string') {
        if (val.includes('T')) {
          const [datePart] = val.split('T');
          const [year, month, day] = datePart.split('-').map(Number);
          return new Date(year, month - 1, day);
        }

        if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
          const [year, month, day] = val.split('-').map(Number);
          return new Date(year, month - 1, day);
        }
      }
      const parts = val.split('/');
      if (parts.length !== 3) return null;
      let day, month, year;
      if (this.dateFormat && this.dateFormat.startsWith('DD')) {
        day = +parts[0];
        month = +parts[1];
        year = +parts[2];
      } else {
        month = +parts[0];
        day = +parts[1];
        year = +parts[2];
      }
      return this.isValidDate(year, month, day)
        ? new Date(year, month - 1, day)
        : null;
    },*/
    parseModel(val) {
      if (!val) return null;

      if (val instanceof Date) return val;

      if (typeof val === 'string') {

        if (val.includes('T')) {
          const [datePart, timePart] = val.split('T');
          const [year, month, day] = datePart.split('-').map(Number);

          // 🔥 SI ES DATE → SIN HORA
          if (this.Type === 'date') {
            return new Date(year, month - 1, day);
          }

          // 🔥 SI ES DATETIME → CON HORA
          let hour = 0;
          let minute = 0;

          if (timePart) {
            const [hh, mm] = timePart.split(':');
            hour = parseInt(hh, 10) || 0;
            minute = parseInt(mm, 10) || 0;
          }

          return new Date(year, month - 1, day, hour, minute);
        }

        // yyyy-MM-dd
        if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
          const [year, month, day] = val.split('-').map(Number);
          return new Date(year, month - 1, day);
        }
      }

      // manual
      const parts = val.split('/');
      if (parts.length !== 3) return null;

      let day, month, year;

      if (this.dateFormat && this.dateFormat.startsWith('DD')) {
        day = +parts[0];
        month = +parts[1];
        year = +parts[2];
      } else {
        month = +parts[0];
        day = +parts[1];
        year = +parts[2];
      }

      return this.isValidDate(year, month, day)
        ? new Date(year, month - 1, day)
        : null;
    },

    formatDate(date) {
      const day = String(date.getDate()).padStart(2,'0');
      const month = String(date.getMonth()+1).padStart(2,'0');
      const year = date.getFullYear();

      if (this.Type === 'datetime') {
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2,'0');

        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        if (hours === 0) hours = 12;

        const hh = String(hours).padStart(2,'0');

        if (this.dateFormat && this.dateFormat.startsWith('DD')) {
          return `${day}/${month}/${year} ${hh}:${minutes} ${ampm}`;
        } else {
          return `${month}/${day}/${year} ${hh}:${minutes} ${ampm}`;
        }
      }

      return this.dateFormat.startsWith('DD')
        ? `${day}/${month}/${year}`
        : `${month}/${day}/${year}`;
    },

    isValidDate(year, month, day) {
      if(month < 1 || month > 12) return false;
      const maxDays = [31, (year%4===0 && year%100!==0) || year%400===0 ? 29 : 28, 31,30,31,30,31,31,30,31,30,31];
      return day >= 1 && day <= maxDays[month-1];
    },

   onInputManual(e) {
    const input = this.$refs.picker.$el.querySelector('input');
    const cursorPos = input.selectionStart;
    if (cursorPos < input.value.length) {
      return;
    }

      this.isTouched = true;
      const isDateTime = this.Type === 'datetime';
      let raw = e.target.value.toUpperCase();
      const maxLength = isDateTime ? 19 : 10;
      if(raw.length > maxLength) {
        e.target.value = raw.substring(0, maxLength);
        return;
      }
      let ampm = '';
      if(isDateTime){
        if(raw.endsWith('AM') || raw.endsWith('A')) ampm = raw.endsWith('AM') ? 'AM' : 'A';
        else if(raw.endsWith('PM') || raw.endsWith('P')) ampm = raw.endsWith('PM') ? 'PM' : 'P';
      }
      let numbers = raw.replace(/\D/g,'');
      numbers = numbers.substring(0, isDateTime ? 12 : 8);
      let block1 = numbers.slice(0,2);
      let block2 = numbers.slice(2,4);
      const rest = numbers.slice(4);

      if(this.dateFormat && this.dateFormat.startsWith('DD')){
        // block1 = día, block2 = mes
        if(block1 && parseInt(block1,10) > 31) block1 = '';
        if(block2 && parseInt(block2,10) > 12) block2 = '';
      } else {
        // block1 = mes, block2 = día
        if(block1 && parseInt(block1,10) > 12) block1 = '';
        if(block2 && parseInt(block2,10) > 31) block2 = '';
      }

      numbers = block1 + block2 + rest;
      let formatted = '';
      if(this.dateFormat && this.dateFormat.startsWith('DD')){
        if(numbers.length<=2) formatted = numbers;
        else if(numbers.length<=4) formatted = numbers.slice(0,2)+'/'+numbers.slice(2);
        else formatted = numbers.slice(0,2)+'/'+numbers.slice(2,4)+'/'+numbers.slice(4,8);
      } else {
        if(numbers.length<=2) formatted = numbers;
        else if(numbers.length<=4) formatted = numbers.slice(0,2)+'/'+numbers.slice(2);
        else formatted = numbers.slice(0,2)+'/'+numbers.slice(2,4)+'/'+numbers.slice(4,8);
      }
      if(isDateTime && numbers.length > 8){
        let hour = numbers.slice(8,10);
        let minute = numbers.slice(10,12);
        if(hour) formatted += ' ' + hour;
        if(minute) formatted += ':' + minute;
        if(numbers.length >= 12) formatted += ' ';
        if(ampm) formatted += ampm;
      }
      this.manualInput = formatted;


      /*this.$nextTick(() => {
        if(this.$refs.picker?.$el){
          const input = this.$refs.picker.$el.querySelector('input');
          if(input) input.value = this.manualInput;
        }
      }); */

      this.$nextTick(() => {
        if(this.$refs.picker?.$el){
          const input = this.$refs.picker.$el.querySelector('input');
          if(input) {
            // 🔥 guardar cursor
           // const start = input.selectionStart;
           // const end = input.selectionEnd;

            input.value = this.manualInput;
            const newPos = input.value.length;
            // 🔥 restaurar cursor
            this.$nextTick(() => {
              input.setSelectionRange(newPos, newPos);
            });
          }
        }
      });



      if(isDateTime && numbers.length >= 12 && (ampm === 'AM' || ampm === 'PM')){
        let day, month, year, hour, minute;
        year = +numbers.slice(4,8);
        if(this.dateFormat && this.dateFormat.startsWith('DD')){
          day = +numbers.slice(0,2);
          month = +numbers.slice(2,4);
        } else {
          month = +numbers.slice(0,2);
          day = +numbers.slice(2,4);
        }
        hour = +numbers.slice(8,10);
        minute = +numbers.slice(10,12);
        if(ampm === 'PM' && hour < 12) hour += 12;
        if(ampm === 'AM' && hour === 12) hour = 0;
       // if(this.isValidDate(year, month, day)) this.internalDate = new Date(year, month-1, day, hour, minute);
      //-----------------------------------------------------------------------------------
       if(this.isValidDate(year, month, day)) {
          const newDate = new Date(year, month-1, day, hour, minute);

          if(this.isInSqlRange(newDate)) {
            this.internalDate = newDate;
          } else {
            this.internalDate = null;
            this.manualInput = '';
            e.target.value = '';
          }
        }
        //---------------------------------------------------------------------------------


      } else if(!isDateTime && numbers.length === 8){
        let day, month, year;
        year = +numbers.slice(4,8);
        if(this.dateFormat && this.dateFormat.startsWith('DD')){
          day = +numbers.slice(0,2);
          month = +numbers.slice(2,4);
        } else {
          month = +numbers.slice(0,2);
          day = +numbers.slice(2,4);
        }
       // if(this.isValidDate(year, month, day)) this.internalDate = new Date(year, month-1, day);
       //------------------------------------------------------------------------------------
       if(this.isValidDate(year, month, day)) {
        const newDate = new Date(year, month-1, day);

        if(this.isInSqlRange(newDate)) {
          this.internalDate = newDate;
        } else {
          this.internalDate = null;
          this.manualInput = '';
          e.target.value = '';
        }
      }
       //------------------------------------------------------------------------------------
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      const input = this.$refs.picker?.$el.querySelector('input');
      if(input){
        this.inputKeydownListener = (e) => {
          if(e.key === 'Enter'){
            this.$nextTick(() => {
              if(this.internalDate && typeof this.OnPressEnter === 'function'){
                this.OnPressEnter();
              }
            });
          }
        };
        input.addEventListener('keydown', this.inputKeydownListener);
      }
    });
  },
  beforeDestroy() {
    const input = this.$refs.picker?.$el.querySelector('input');
    if(input && this.inputKeydownListener){
      input.removeEventListener('keydown', this.inputKeydownListener);
    }
  }
}
</script>
